import React from 'react';
import { Bubble } from 'tea-component';
import { useIntl } from 'umi';
const TABLEPADDING = 40; // 列表列的padding为20，左右加起来为40

interface PropsType {
  width?: number | string;
  align: 'left' | 'right' | 'center';
  children: React.ReactNode;
  titleStyle?: Boolean;
  style?: any;
  hoverTipsKey?: string;
  classNameValue?: string;
}

const CloumsCenter = (props: PropsType) => {
  const {
    width,
    align,
    children,
    titleStyle,
    style,
    hoverTipsKey = '',
    classNameValue = '',
  } = props;
  // console.log('CloumsCenterCloumsCenter', props);
  const { formatMessage } = useIntl();
  // width:
  // - undefined: keep legacy default width
  // - 'auto': let content decide width (table cell padding stays intact)
  // - number/'100%': fixed width handling
  const styleWidth =
    width === 'auto'
      ? undefined
      : width === '100%'
        ? width
        : (Number(width) || 140) - TABLEPADDING;
  return hoverTipsKey !== '' ? (
    <>
      <Bubble content={formatMessage({ id: hoverTipsKey })} dark>
        <div
          style={{
            ...(styleWidth ? { width: styleWidth } : {}),
            textAlign: align,
            display: 'inline-block',
            verticalAlign: 'middle',
            color: titleStyle ? '#262832' : '',
            ...style,
          }}
        >
          {children}
        </div>
      </Bubble>
    </>
  ) : (
    <div
      style={{
        ...(styleWidth ? { width: styleWidth } : {}),
        textAlign: align,
        display: 'inline-block',
        verticalAlign: 'middle',
        color: titleStyle ? '#262832' : '',
        ...style,
      }}
      className={classNameValue}
    >
      {children}
    </div>
  );
};

export default CloumsCenter;
